import React, { Component, PropTypes } from 'react'
import { Icon } from '../containers/LayoutContainer/Header/Menu/LeftMenu/LeftMenu.style';
import DashboardIcon from '@material-ui/icons/Dashboard';
import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows';
import LocalMall from '@material-ui/icons/LocalMall';

const SidebarData = [
    /*{
        name: "Dashboard",
        icon: <DashboardIcon />,
        link: "/supplier/dashboard"
    },*/
    // {
    //     name: "Products",
    //     icon: <DesktopWindowsIcon />,
    //     link: "/admin/products"
    // },
    // {
    //     name: "Categories",
    //     icon: <DesktopWindowsIcon />,
    //     link: "/admin/categories"
    // },
    // {
    //     name: "SubCategories",
    //     icon: <DesktopWindowsIcon />,
    //     link: "/admin/subCategories"
    // },
    // {
    //     name: "Brand",
    //     icon: <DesktopWindowsIcon />,
    //     link: "/admin/brands"
    // },
    // {
    //     name: "Bulk Uploads",
    //     icon: <DesktopWindowsIcon />,
    //     link: "/admin/bulkUploads"
    // },
    // {
    //     name: "Bulk Images Upload",
    //     icon: <DesktopWindowsIcon />,
    //     link: "/admin/bulkImageUploads"
    // },
    {
        name: "Order",
        icon: <DesktopWindowsIcon />,
        link: "/supplier/orders"
    },
    {
        name: "Stock Management",
        icon: <LocalMall />,
        link: "/supplier/stocks",
    }


];

export default SidebarData;